import { Star } from 'iconoir-react/solid';
import { CtaButton } from '@/components/astro/cta-button/cta-button';
import * as m from '@/paraglide/messages';

export function FinalCtaSection() {
  return (
    <section
      aria-labelledby='why-final-heading'
      className='px-3 pb-6 sm:px-6 sm:pb-10'
    >
      <div className='relative isolate mx-auto max-w-6xl overflow-hidden rounded-[32px] bg-(--v2-text-primary) px-6 py-16 text-center sm:px-10 sm:py-24'>
        <div
          aria-hidden='true'
          className='absolute inset-x-0 -bottom-40 -z-10 mx-auto h-96 max-w-2xl rounded-full bg-azure-595/35 blur-[120px]'
        />
        <div
          aria-hidden='true'
          className='absolute inset-0 -z-10 bg-[radial-gradient(rgb(255_255_255/0.06)_1px,transparent_1px)] [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)] bg-size-[22px_22px]'
        />
        <h2
          className='mx-auto max-w-3xl text-[36px] leading-[1.02] font-semibold tracking-[-0.045em] text-balance text-white sm:text-6xl'
          id='why-final-heading'
        >
          {m.why_listening_final_title()}
        </h2>
        <p className='mx-auto mt-5 max-w-xl text-base leading-relaxed text-pretty text-white/60 sm:text-lg'>
          {m.why_listening_final_description()}
        </p>
        <div className='mt-9 flex justify-center'>
          <CtaButton
            className='h-13 w-full max-w-xs px-8 py-0 text-base font-semibold shadow-[0_8px_30px_rgb(5_135_251/0.4)] transition hover:-translate-y-px hover:bg-primary/90 sm:h-14 sm:w-auto sm:text-[17px]'
            label={m.common_try_for_free()}
            variant='default'
          />
        </div>
        <p className='mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm text-white/55'>
          <span className='inline-flex items-center gap-1.5'>
            <Star aria-hidden='true' className='size-3.5 text-gold-375' />
            <span className='font-semibold text-white/85'>4.4</span>
            {m.why_listening_hero_rating_short()}
          </span>
          <span aria-hidden='true' className='hidden text-white/20 sm:inline'>
            /
          </span>
          <span>{m.why_listening_compare_platforms()}</span>
        </p>
      </div>
    </section>
  );
}
